"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImage = void 0;
const getImage = ({ httpClient, }) => ({ image_id, slug, }) => {
    const path = '/images';
    const url = `${path}/${image_id || slug}`;
    return httpClient.get(url);
};
exports.getImage = getImage;
//# sourceMappingURL=get-image.js.map